import { IGetSurveyMemberGroupFilter } from './surveyAdd/ListOfMembers/types';
import {
  DisplayFormat,
  IDepartment,
  IGetSurveyInfomation,
  IListOfBonusCode,
  SelectType,
  SurveyForm,
  SurveyObjects,
  SurveyObjects360,
  SurveyStatus,
  SurveyTypes,
  IMemberGroupInfo,
  IMemberGroupLabel,
} from './surveyAdd/type';
import { Range } from 'utils/helperFunctions';

export const tabControllers = [
  {
    value: SelectType.information,
    label: 'Thông tin chung',
  },
  {
    value: SelectType.content,
    label: 'Nội dung',
  },
  {
    value: SelectType.memberList,
    label: 'Danh sách thành viên',
  },
  {
    value: SelectType.release,
    label: 'Phát hành',
  },
  {
    value: SelectType.surveyResult,
    label: 'Kết quả khảo sát',
  },
];

export const listSurveyForm = [
  {
    key: 2,
    value: SurveyForm.PRIVATE,
  },
  {
    key: 1,
    value: SurveyForm.PUBLIC,
  },
] as unknown as { key: string; value: string }[];

export const surveyFormConstant: Record<string, number> = {
  public: 1,
  private: 2,
};

export const listSurveyTypes = [
  {
    key: 1,
    value: SurveyTypes.NORMAL,
  },
  {
    key: 2,
    value: SurveyTypes.SURVEY_360,
  },
] as unknown as { key: string; value: string }[];

export const surveyTypeConstant: Record<string, number> = {
  normal: 1,
  survey360: 2,
};

export const listSurveyObject = [
  {
    key: 1,
    value: SurveyObjects.INTERNAL,
  },
  {
    key: 2,
    value: SurveyObjects.EXTERNAL,
  },
] as unknown as { key: string; value: string }[];

export const surveyObjectConstant: Record<string, number> = {
  internal: 1,
  external: 2,
};

export const surveyAppIDConstant = {
  guongThan: 'guong-than',
} as const;

export interface ISurveyObject360 {
  objectID: Range<0, 5>;
  objectName: string;
}

export const listSurvey360Objects = [
  {
    objectID: 1,
    objectName: SurveyObjects360.SUPERIOR,
  },
  {
    objectID: 2,
    objectName: SurveyObjects360.INFERIOR,
  },
  {
    objectID: 3,
    objectName: SurveyObjects360.COUNTERPART,
  },
  {
    objectID: 4,
    objectName: SurveyObjects360.SELF_ASSESSMENT,
  },
] as ISurveyObject360[];

export const listSurveyUser360Objects = [
  {
    objectID: 1,
    objectName: SurveyObjects360.SUPERIOR,
  },
  {
    objectID: 2,
    objectName: SurveyObjects360.INFERIOR,
  },
] as ISurveyObject360[];

export const listDisplayFormat = [
  {
    key: 1,
    value: DisplayFormat.VIEW_ALL,
  },
  {
    key: 2,
    value: DisplayFormat.HIGHLIGHT,
  },
] as unknown as { key: string; value: string }[];

export const listStatus = [
  {
    key: '2',
    value: SurveyStatus.EDITING,
  },
  {
    key: '1',
    value: SurveyStatus.PUBLISHED,
  },
  {
    key: '3',
    value: SurveyStatus.FINISHED,
  },
  {
    key: '4',
    value: SurveyStatus.LOGGED,
  },
] as unknown as { key: string; value: string }[];

export const listEmbedApp = [
  {
    key: 'GStars',
    value: 'G-Stars',
  },
  {
    key: 'TGS',
    value: 'TGS',
  },
  {
    key: 'GOffice',
    value: 'G-Office',
  },
  {
    key: 'GHero',
    value: 'G-Hero',
  },
] as unknown as { key: string; value: string }[];

export const allowedFrequency = [
  {
    key: 'false',
    value: 'Một lần',
  },
  {
    key: 'true',
    value: 'Nhiều lần',
  },
];

export const isShowResult = [
  {
    key: 'false',
    value: 'Không',
  },
  {
    key: 'true',
    value: 'Có',
  },
];

export const defaultSurveyInformation: IGetSurveyInfomation = {
  surveyID: '',
  surveyName: '',
  status: 2,
  surveyViewers: [],
  surveyType: 1,
  surveyForm: 0,
  surveyObject: 1,
  survey360Objects: listSurvey360Objects,
  displayFormat: 1,
  campaignID: '',
  awardee: 0,
  allowedFrequency: 'false',
  isShowResult: 'false',
  /** */
  startDate: null,
  endDate: null,
  /** */
  description: '',
  thanksContent: '',
  departments: [],
  apps: [],
  objectGroup: 1,
  peopleInfo: null,
  userID: '',
  totalBonusCodesMax: 0,
  totalBonusCodesSafe: 0,
  surveyBonusCodes: [],
  copySurvey: false,
  isCompleteCopySurvey: false,
  resetStaff: 0,
  regionIDGroups: [],
  unitIDGroups: [],
  divisionIDGroups: [],
  restaurantsIDGroups: [],
  positionIDGroups: [],
  levelIDGroups: [],
  departmentIDGroups: [],
  userCanViewSurvey: [],
  userCanUpdateSurvey: [],
};

export const defaultListOfBonusCode: IListOfBonusCode = {
  totalItem: 0,
  contents: [],
};

export const surveyMemberGroupFilterDefault: IGetSurveyMemberGroupFilter = {
  regions: [],
  units: [],
  departments: [],
  divisions: [],
  restaurants: [],
  positions: [],
  levels: [],
  outlook: [],
};

export const defaultQuestionEvaluatedWhenUpdateQuestion = (departments: IDepartment[]) => ({
  questionID: '',
  questionTypeID: '10',
  questionGroupID: 'GGENE',
  departments: departments,
  questionContent: 'Người được đánh giá',
  imagePath: '',
  isRequired: true,
  isDropDown: true,
  isHaveOther: false,
  isMatrix: false,
  isMultipleSelect: false,
  iconType: 0,
  maxLevel: 0,
  isRating: false,
  isQuestionBank: false,
  isUsed: true,
  nextQuestion: '',
  answers: [],
  matrixAnswers: [],
});

export const defaultQuestionEvaluated = (departments: IDepartment[], surveyID: string) => ({
  questionID: '',
  questionTypeID: '10',
  questionGroupID: 'GGENE',
  departments: departments,
  questionContent: 'Người được đánh giá',
  isRequired: true,
  isDropDown: true,
  isHaveOther: false,
  isQuestionBank: true,
  isDeleteImage: false,
  nextQuestion: '',
  answers: [],
  surveyID: surveyID,
});

export const defaultMemberGroupRequestInfo = {
  conditions: [],
  isSelectAll: false,
  nextPage: 0,
  page: 1,
  pageSize: 20,
  pageSizeNextPage: 20,
  surveyID: '',
  keySearch: '',
  conditionSelect: [],
};

const defaultMemberGroupResponseInfo = {
  page: 1,
  pageSize: 20,
  totalItem: 1,
  totalPage: 1,
};

const defaultGroupInfo = {
  isSelectAllOption: false,
  requestInfo: defaultMemberGroupRequestInfo,
  responseInfo: defaultMemberGroupResponseInfo,
};

export const minTotalPage = 1;
export const minRecord = 20;

export const defaultMemberGroupInfo = {
  regionGroup: defaultGroupInfo,
  unitGroup: defaultGroupInfo,
  departmentGroup: defaultGroupInfo,
  divisionGroup: defaultGroupInfo,
  restaurantGroup: defaultGroupInfo,
  positionGroup: defaultGroupInfo,
  levelGroup: defaultGroupInfo,
  outlookMail: defaultGroupInfo,
};

export const convertNameMemberGroup: Record<IMemberGroupLabel, keyof IMemberGroupInfo> = {
  regions: 'regionGroup',
  units: 'unitGroup',
  departments: 'departmentGroup',
  divisions: 'divisionGroup',
  restaurants: 'restaurantGroup',
  positions: 'positionGroup',
  levels: 'levelGroup',
  outlooks: 'outlookMail',
};

export const memberGroupRequest = {
  page: 1,
  pageSize: 20,
  surveyID: '',
  isSelectAll: false,
  conditions: [],
  nextPage: 0,
  pageSizeNextPage: 20,
  conditionSelect: [],
};

export enum TypeSelectedOption {
  ALL = 'select all options',
  MANY = 'choose a lot of options',
  LITTLE = 'choose few options',
}

export const defaultLoadingMemberGroupInfo = {
  regions: false,
  units: false,
  departments: false,
  divisions: false,
  restaurants: false,
  positions: false,
  levels: false,
  outlooks: false,
};

export const selectionLoadingUIMemberGroup = {
  regions: 'units',
  units: 'departments',
  departments: 'divisions',
  divisions: 'restaurants',
  restaurants: '',
  positions: '',
  levels: '',
  outlooks: '',
};

export const allOptionUserViewer = {
  id: null,
  surveyID: '',
  viewerDetail: '',
  viewerID: 'all',
  viewerName: 'Tất cả',
};

export const defaultParamFiltersEvaluatedQuestion = {
  regionIDs: [],
  unitIDs: [],
  divisionIDs: [],
  restaurantsIDs: [],
  positionIDs: [],
  levelIDs: [],
  departmentIDs: [],
};

export const actionUpdateStaffsConstant = {
  KEEP_STATE: 0,
  CLEAR_STATE: 1,
};

export const typeFormatDisplayQuestionInDoSurvey = {
  VIEW_ALL: 1,
  HIGHLIGHT: 2,
};

export const typeTemplateQuestionExcel: Record<'QUESTION_BANK' | 'SURVEY', 1 | 2> = {
  QUESTION_BANK: 1,
  SURVEY: 2,
};

export const CATEGORY_TYPE_STAFF = 12;

export const placeholderDropdownStaff =
  'Tìm kiếm nhiều tiêu chí cách nhau bằng dấu ",". Ví dụ: Tìm kiếm nhân viên có tên Nam ở phòng Đào tạo, có thể search: Nam, Đào tạo';
